import { render, staticRenderFns } from "./VTableCell.vue?vue&type=template&id=615abc1c&functional=true&"
var script = {}
import style0 from "./VTableCell.vue?vue&type=style&index=0&id=615abc1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports